import React from "react";
import { default as Head } from "next/head";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";
import { IGroupProps } from "~/components/group/IGroupProps";
import { Tab } from "~/components/seo/common";

interface IGroupPageSeoProps extends IGroupProps {
  tab: Tab | string;
}

export default function GroupPageSeo({ group, tab }: IGroupPageSeoProps) {
  const { name, about, logo } = group;

  return (
    <>
      <SeoHead title={getGroupFormattedTitle(tab, name)} description={about || ""} />
      <Head>
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Govlaunch" />
        <meta name="twitter:image" content={logo || ""} />

        <meta property="og:image" content={logo || ""} />
      </Head>
    </>
  );
}

function getGroupFormattedTitle(tab: Tab | string, groupName: string) {
  const intl = useIntl();

  if (!groupName) {
    return intl.formatMessage({
      defaultMessage: "Search the wiki for local government innovation groups.",
      id: "QVn/Wh",
    });
  }

  switch (tab) {
    case "projects":
      return intl.formatMessage(
        { defaultMessage: "{groupName} – Govlaunch Projects", id: "VjzTfE" },
        { groupName: groupName },
      );
    case "products":
      return intl.formatMessage(
        { defaultMessage: "{groupName} – Govlaunch Products", id: "Kp+DQG" },
        { groupName: groupName },
      );
    case "actions":
      return intl.formatMessage(
        { defaultMessage: "{groupName} – Govlaunch Actions", id: "tqsGax" },
        { groupName: groupName },
      );
    case "newsworthy":
      return intl.formatMessage(
        { defaultMessage: "{groupName} – Govlaunch Newsworthy", id: "rIaIHL" },
        { groupName: groupName },
      );
    default:
      return intl.formatMessage({ defaultMessage: "{groupName} – Govlaunch", id: "129gsZ" }, { groupName: groupName });
  }
}
